module.exports = "/_next/static/resources/photo-2-8eeff20b8d85f33183d308aa4e5a1ec6.webp";